import React from "react";
import Select from '../../common/Select';
import { DropdownIndicator } from "../../../utils/dropdown-override";

function MonthDayRangeComponent({ min, max, Dyn, mode, onChange }) {

    function getLoc(str) {
        return Dyn.loc(str);
    }

    if (mode == "month") {
        var options = [
            { value: "0", label: "January" },
            { value: "1", label: "February" },
            { value: "2", label: "March" },
            { value: "3", label: "April" },
            { value: "4", label: "May" },
            { value: "5", label: "June" },
            { value: "6", label: "July" },
            { value: "7", label: "August" },
            { value: "8", label: "September" },
            { value: "9", label: "October" },
            { value: "10", label: "November" },
            { value: "11", label: "December" },
        ];
    } else {
        var options = [
            { value: "0", label: "Sunday" },
            { value: "1", label: "Monday" },
            { value: "2", label: "Tuesday" },
            { value: "3", label: "Wednesday" },
            { value: "4", label: "Thursday" },
            { value: "5", label: "Friday" },
            { value: "6", label: "Saturday" },
        ];
    }

    // checking if while converting from categorical to numerical if there is
    // no valid numeric value.
    if (typeof min === "undefined" || typeof max === "undefined") {
        return (
            <div className="tde-numeric-component">
                <div className="tde-m-2 tde-text-error">
                    {getLoc("No valid numeric value for the attribute.")}
                </div>
            </div>
        );
    } else {
        return (
            <div className="tde-flex">
                <div className="tde-row tde-my-2">
                    <div className="tde-label tde-mb-2">{getLoc("Min")}</div>
                    <Select
                        Dyn={Dyn}
                        className="tde-input tde-select-input tde-input-select tde-monthday-range"
                        isClearable={false}
                        value={options.find((obj) => obj.value == min)}
                        options={options}
                        // openMenuOnFocus
                        isSearchable={false}
                        tabSelectsValue={false}
                        onChange={(e) => {
                            onChange([e.value, max]);
                        }}
                        components={{
                            Option: ({
                                data,
                                innerProps,
                                children,
                                innerRef,
                                isSelected,
                                isFocused,
                            }) => (
                                <div
                                    className={
                                        "tde-select-option" +
                                        (isSelected? " tde-selected": "") +
                                        (isFocused? " tde-focused": "")
                                    }
                                    role="option"
                                    aria-selected={isSelected ? "true" : "false"}
                                    title={data.title}
                                    {...innerProps}
                                    ref={innerRef}
                                >
                                    <div className="tde-s1">{children}</div>
                                </div>
                            ),
                            DropdownIndicator,
                        }}
                    />
                </div>
                <div className="tde-row tde-my-2">
                    <div className="tde-label tde-mb-2">{getLoc("Max")}</div>
                    <Select
                        Dyn={Dyn}
                        className="tde-input tde-select-input tde-input-select"
                        isClearable={false}
                        value={options.find((obj) => obj.value == max)}
                        options={options}
                        // openMenuOnFocus
                        isSearchable={false}
                        tabSelectsValue={false}
                        onChange={(e) => {
                            onChange([min, e.value]);
                        }}
                        components={{
                            Option: ({
                                data,
                                innerProps,
                                children,
                                innerRef,
                                isSelected,
                                isFocused,
                            }) => (
                                <div
                                    className={
                                        "tde-select-option" +
                                        (isSelected? " tde-selected": "") +
                                        (isFocused? " tde-focused": "")
                                    }
                                    role="option"
                                    aria-selected={isSelected ? "true" : "false"}
                                    title={data.title}
                                    {...innerProps}
                                    ref={innerRef}
                                >
                                    <div className="tde-s1">{children}</div>
                                </div>
                            ),
                            DropdownIndicator,
                        }}
                    />
                </div>
            </div>
        );
    }
}

export default MonthDayRangeComponent;
